<router-outlet></router-outlet>

<nbc-loader></nbc-loader>
<nbc-idle></nbc-idle>
